import React, { useCallback } from "react";
import { FormGroup } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { messages } from "./messages";
import {
  CheckboxContentWrapper,
  CheckboxesContainer,
  DisplaySecondaryLabel,
  LabelWrapper,
  MultiCheckboxContainer,
  SelectAllNoneContainer,
  SelectStatusCheckboxes,
} from "./styles";

const isChecked = ({ value, ticker }: { value: string; ticker: string }) => {
  return (value && value.indexOf(ticker) >= 0) || value === ticker;
};

export const FormGroupStyled = styled(({ multiCheckboxType, disabled, ...rest }: any) => (
  <FormGroup {...rest} />
))`
  ${props => (props.disabled ? `pointer-events: none;` : ``)}
  .checkbox label {
    ${props =>
      props.multiCheckboxType === "LIST"
        ? "display: block !important"
        : "display: inline-block !important"};
  }
`;

export const InputMultiCheckbox = ({
  defaultValues,
  onChange,
  name,
  value,
  field,
  relatedEntities,
  locale,
  className,
  horizontal,
  getDisplay,
  getSecondDisplay,
  ...rest
}: any) => {
  const handleOnChange = useCallback(
    ({ event, ticker }: any) => {
      const val = value || [];
      const newVal = event.target.checked
        ? [...val, ticker]
        : val.filter((it: any) => it !== ticker);
      onChange([...newVal]);
    },
    [onChange, value]
  );

  const setTrueAllCheckboxes = useCallback(() => {
    const { options, entity } = field;
    const checkBoxList = (relatedEntities && relatedEntities[entity]) || options || [];
    onChange([...checkBoxList.map((value: any) => value.ticker)]);
  }, [field, onChange, relatedEntities]);

  const setFalseAllCheckboxes = () => onChange([]);

  const {
    description,
    options,
    disabled,
    selectables,
    entity,
    entityDisplay,
    mapping,
    multiCheckboxType,
  } = field;

  const checkBoxList = (relatedEntities && relatedEntities[entity]) || options || [];

  return (
    <div className={`${className} multicheckboxGroup`}>
      <FormGroupStyled multiCheckboxType={multiCheckboxType} disabled={disabled}>
        <div className="multicheckbox checkbox c-checkbox needsclick">
          <div>
            {description}
            <MultiCheckboxContainer className={"multicheckboxes-container"}>
              {selectables && (
                <SelectAllNoneContainer>
                  <SelectStatusCheckboxes onClick={setTrueAllCheckboxes}>
                    <FormattedMessage {...messages.selectAll} />
                  </SelectStatusCheckboxes>
                  &nbsp;/&nbsp;
                  <SelectStatusCheckboxes onClick={setFalseAllCheckboxes}>
                    <FormattedMessage {...messages.deselectAll} />
                  </SelectStatusCheckboxes>
                </SelectAllNoneContainer>
              )}
              {checkBoxList.map((option: any) => {
                let displayLabel =
                  (mapping && mapping[locale] && mapping[locale][option[entityDisplay]]) ||
                  option[entityDisplay] ||
                  (getDisplay && getDisplay(option)) ||
                  option.name;

                let displaySecondaryLabel = getSecondDisplay ? getSecondDisplay(option) : null;

                return (
                  <CheckboxContentWrapper key={option.ticker}>
                    <LabelWrapper>
                      <label className="needsclick">
                        <CheckboxesContainer>
                          <input
                            name={name}
                            disabled={disabled}
                            type="checkbox"
                            className="needsclick-input"
                            checked={isChecked({
                              value: value || defaultValues,
                              ticker: option.ticker,
                            })}
                            onChange={event =>
                              handleOnChange({
                                event,
                                ticker: option.ticker,
                              })
                            }
                            {...rest}
                          />
                          <em className="fa fa-check" />
                          {displayLabel}
                          {displaySecondaryLabel && (
                            <DisplaySecondaryLabel>
                              {`(${displaySecondaryLabel})`}
                            </DisplaySecondaryLabel>
                          )}
                        </CheckboxesContainer>
                      </label>
                    </LabelWrapper>
                  </CheckboxContentWrapper>
                );
              })}
            </MultiCheckboxContainer>
          </div>
        </div>
      </FormGroupStyled>
    </div>
  );
};
